import { render, staticRenderFns } from "./DeviceViewPCMotherboard.vue?vue&type=template&id=bef628ca&scoped=true&"
import script from "./DeviceViewPCMotherboard.vue?vue&type=script&lang=js&"
export * from "./DeviceViewPCMotherboard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceViewPCMotherboard.vue?vue&type=style&index=0&id=bef628ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef628ca",
  null
  
)

export default component.exports